import { ItemDetailDto } from "@/types/dto/item-detail-dto";
import { atom } from "recoil";

export interface ItemModalState extends ItemDetailDto {
  selectedIds?: number[];
  onSuccess?: () => void;
}

export const isNotOpenForSaleModal = atom<ItemModalState | undefined>({
  key: "isNotOpenForSaleModal",
  default: undefined,
});
